import { Box, Checkbox, List, Tag, Text } from '@factorialco/deprecated-design-system'
import { TasksTaskFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { Task } from 'modules/employee_onboarding/hooks/useTasksFilter'
import { dueDateState } from 'modules/notifications/lib/DueDateState'

import DueStateLabel from './DueStateLabel'
import Settings from './Settings'

interface Props {
  task: Task
  mandatory?: boolean
  onToggle: (task: TasksTaskFragment) => Promise<void>
}

const TaskView = ({ task, onToggle }: Props) => {
  const { id, name, dueOn, mandatory } = task
  const { navigation } = useNavigation()

  const taskRoute = navigation.employee_onboarding.onboardingTasks.taskDetail.fullPath({
    taskId: task.id,
  })
  const dueDate = dueOn ? stringToDate(dueOn, 'backend') : null
  const dueState = dueDate ? dueDateState(dueDate) : null
  const completed = task.completedAt

  const handleToggleTask = () => onToggle(task)

  return (
    <List.Item key={id}>
      <List.Title>
        <Box flexDirection="row" gap="s24">
          <Checkbox checked={completed} onChange={handleToggleTask} size="large" />
          <Box flexDirection="column" gap="s4">
            <Text.Normal color="grey1000" weight="medium" stroked={completed}>
              {name}
            </Text.Normal>
            <DueStateLabel state={dueState} dueOn={dueDate} />
          </Box>
        </Box>
      </List.Title>
      <List.Description>
        <Box flexDirection="row" gap="s24" alignItems="center">
          <Box>
            {mandatory && (
              <Tag type="grey" inline>
                {i18n.t('employees.onboarding_task.mandatory')}
              </Tag>
            )}
          </Box>
          <Settings route={taskRoute} />
        </Box>
      </List.Description>
    </List.Item>
  )
}

export default TaskView
